import Box from "@mui/material/Box"
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"

import Row from "../../../../../common/components/Row"

export default function ChartCard({
  title,
  legendLabel1,
  legendLabel2,
  chartHeight,
  children,
}) {
  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 2,
        height: chartHeight + 100,
      }}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          {title}
        </Typography>
        <Box sx={{ width: "100%", height: chartHeight }}>{children}</Box>
        <ChartLegend label1={legendLabel1} label2={legendLabel2} />
      </CardContent>
    </Card>
  )
}

function ChartLegend({ label1, label2 }) {
  return (
    <Row sx={{ justifyContent: "center", gap: 3, mt: 2 }}>
      <LabeledHorizontalBar label={label1} barColor="#9525D6" />
      <LabeledHorizontalBar label={label2} barColor="#D386FF" />
    </Row>
  )
}

function LabeledHorizontalBar({ label, barColor }) {
  return (
    <Row sx={{ alignItems: "center", gap: 1 }}>
      <HorizontalBar
        sx={{
          backgroundColor: barColor,
        }}
      />
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
    </Row>
  )
}
const HorizontalBar = styled(Box)(({ theme }) => ({
  width: 16,
  height: 3,
  borderRadius: 1,
}))
